import styled from '@emotion/styled';
import { IconButton, Paper, Typography } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import { ClassAttributes, createElement, MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_REGULAR, SPACING_UNIT } from '../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';
import AnchorTypography from '../primitive/AnchorTypography';
import _PerformanceReportNetworkWithIcon from './PerformanceReportNetworkWithIcon';

interface Props {
  onClose: (e: MouseEvent) => void;
  className?: string;
}

const FacebookReportingIntegrationBanner = ({ onClose, className }: ClassAttributes<HTMLElement> & Props) => {
  return (
    <Root className={className}>
      <CloseButton>
        <IconButton onClick={onClose}>
          <Close fontSize="small" />
        </IconButton>
      </CloseButton>
      <PerformanceReportNetworkWithIcon network={'facebook'} />
      <IntegrationStatus>
        <FormattedMessage id="facebook_reporting_integration_banner.status_label" />
      </IntegrationStatus>
      <IntegrationGuide>
        <FormattedMessage id="facebook_reporting_integration_banner.guide" />
      </IntegrationGuide>
      <Actions>
        <FormattedMessage id="help.reporting_integration_facebook">
          {(url: string) => (
            <AnchorTypography withNewTab href={url}>
              <FormattedMessage id="facebook_reporting_integration_banner.help" />
            </AnchorTypography>
          )}
        </FormattedMessage>
      </Actions>
    </Root>
  );
};

const Root = styled(Paper)({
  ...gridLayoutContainer({
    areas: [['network'], ['status'], ['guide'], ['actions']],
    columns: ['auto'],
    rows: ['auto', 'auto', 'auto', 'auto'],
    alignItems: 'center',
  }),
  padding: SPACING_REGULAR,
  position: 'relative',
});

const PerformanceReportNetworkWithIcon = styled(_PerformanceReportNetworkWithIcon)({
  ...gridLayoutItem('network'),
  marginBottom: SPACING_UNIT,
});

const CloseButton = styled('div')({
  position: 'absolute',
  top: SPACING_UNIT,
  right: SPACING_UNIT,
});

const IntegrationStatus = styled(Typography)({
  ...gridLayoutItem('status'),
  marginBottom: SPACING_UNIT,
});
IntegrationStatus.defaultProps = { variant: 'body2', color: 'textSecondary' };

const IntegrationGuide = styled(Typography)({
  ...gridLayoutItem('guide'),
  marginBottom: SPACING_UNIT,
});
IntegrationGuide.defaultProps = { variant: 'caption', color: 'textSecondary' };

const Actions = styled('div')({
  ...gridLayoutItem('actions'),
});

export default FacebookReportingIntegrationBanner;
